
    <!-- ::用法示例::
      <mytable
        ref='table_selectMyAttention'
        :tableColums='tableColums_selectMyAttention||[]'

        api='selectMyAttention'
        x:data='selectMyAttention_data.data||[]'

        v-event.selectMyAttention='`selectMyAttention({})`'

        :height="H-285"

        @current-change="(row,oldrow,table)=>{}"

        @row-click="(row,oldrow,table)=>{}"
        >
        <img slot='imageinfo' :src="$row." alt="">
      </mytable>
    -->

<template>

  <div v-loading='firstRequest === true ? true : boolean === 0 ? false : boolean||dataReady === false||!!$route.meta.refresh'
       element-loading-background='rgba(255,255,255,0.5)'
       :element-loading-text='(window.Apis[bindapi]||0).$tip' class="blackFont" 
       >
    <section
        vs:250.visibility=' _warn( $host._isMounted && dataReady && window.App.Appload === "mounted" && !$route.meta.refresh, "refresh::", $route.meta.refresh, dataReady ) ? "visible" : "hidden"'
        v-s:250.visibility=' firstRequest === true ? "hidden" : $host._isMounted && dataReady && window.App.Appload === "mounted" && !$route.meta.refresh ? "visible" : "hidden" '
        >

      <!-- _error(_self,bindrowkey,computedData) -->
      <el-table
        ref='table'
        :data="!$attrs.tree || !$attrs.tree.lazy ? computedData : nowData? nowData:computedData.map(v=>($emit('hasChildrenChange', v) || true, v))"
        @expand-change="$emit('expand', $event, typeof arguments[1] === 'boolean' ? arguments[1] : (arguments[1]||[]).includes($event), arguments[1])"
        current-change=""
        row-click=""
        :row-key="bindrowkey||'$_$'"
        :tree-props="$attrs.tree || {}"
        :lazy="$attrs.tree ? !!$attrs.tree.lazy : false"
        :load="$attrs.tree ? $attrs.tree.lazy : null"
        v-bind="$attrs"
        v-on="$listeners"
        vviewselectContact_data.data

        remark="👆上面是自定义的,👇下面是固定的无需修改"

        :height="height||H-165"
        vs:250.visibility=' ( _warn( $host._isMounted && dataReady && window.App.Appload === "mounted" && !$route.meta.refresh, "refresh::", $route.meta.refresh ) ? "visible" : "hidden" ) '
        v-s:450.height=' window.App.Appload === "mounted" ?  height || H-165 : 0 '

        :header-cell-style="$$headerStyle"
        highlight-current-row border
        xcache:userId='_rowCache(arguments,arguments[4] && toShow)' >

        <el-table-column v-if='tableSelection' type='selection' :fixed='tableSelectionFixed||"left"' :width='tableSelectionWidth' class-name='el-table-index' align='center' x:reserve-selection='!!bindrowkey' />
        <el-table-column v-if='tableIndex !== null' type='index' :fixed='tableIndexFixed' :width='tableIndexWidth' :index='$$setIndex.bind($host,binddata)' :label='tableIndex' class-name='el-table-index' align='center' />
        <!-- <el-table-column v-if="$scopedSlots.expand" type='expand' :label="$slots.expand[0].data.attrs.label||''" >
          <template slot-scope="props" >
            <slot name='expand' :row='props.row' ></slot>
            <div slot="expand" label="👇" >
              7777777777777 | \src\views\User\UserTargerMine.vue
            </div>
          </template>
        </el-table-column> -->

        <el-table-column
          v-for='(column,prop) in MyTableColums' :key='prop'
          :label="!updateapi_rule[prop] ? column.title : '\uE78c ' + column.title"
          :prop='prop'
          :sortable='column.sortable||false'
          :width='column.width'
          :fixed='column.fixed'
          :align='column.align||"center"'
          :show-overflow-tooltip='!$slots[prop] || $slots[prop][0].data.attrs.showtooltip !== false'
          >
          <template slot-scope='{row,$index,column:col}' >
            <!-- <span v-if='row && !row.$_rendered_$' :row='( $host[bindata_key].$$row = row ).$_rendered_$ = true'>
                {{ _warn( 55555555555555, ( $host[bindata_key].$$row = row ).$_rendered_$ = true, row.$_rendered_$, $host[bindata_key].$$row,  $host[bindata_key] ) }}
            </span> -->
            <!-- <div > -->
              <span v-if='prop[0] !== "$" && updateapi_rule[prop] && row && !row.$$_oldrow_$$ ' v-set='el=>{
                row.hideProperty( "$"+prop, row[prop] ).hideProperty("$edit" + prop,false).hideProperty("$$_oldrow_$$",true);
              }' vhide='' />

              <div 
               xv-if='{
                    display: ( dataReady, prop[0] === "$" || !updateapi_rule[prop] ? true : !row[ "$edit" + prop ]  && row[prop] === row["$"+prop] ) ? "" : "none"
                }'
               :onclick='prop[0] !== "$" && updateapi_rule[prop] &&
                `
                const target = event.target;
                if( target.nodeName === "BUTTON" || target.parentNode.nodeName === "BUTTON" ) return;
                // if( target === this && this.textContent.trim() !== "" ) return;
                const row = this.row, prop = this.prop;
                // console.error(row,prop);
                if( this.this.focusEditable(row,prop) )
                  Vue.nextTick(()=> sleep(20, v=>{
                    ( v = this.nextElementSibling || this ) && ( v = v.children[1].children[0] ).focus(v.select());
                  }) );
               `'
               v-set='div=>div.onclick && $nextTick(td=>{
                (td=div.parentNode.parentNode).style.cursor = "text", td.title = "点击编辑";
               })'
               style='min-height:40px;line-height:40px;' px23px
               :row.prop='row' :prop.prop='prop' :this.prop='$this' class="el-cell" >
                <div v-if='$scopedSlots[prop] || $slots[prop]'
                   :slotname.prop='prop'
                   :row.prop='row'
                   x:table.prop='Table'

                   x:index.prop='$index'
                   x:column.prop='col'
                   >
                  <slot
                    :name='prop'
                    :row='row'
                    x:test='_warn(row.rolename,$index, $slots[prop][0].child)'
                    x:func='Cachedfns()'
                    />
                </div>

                <span v-else-if='column.istext'>{{ row[prop] != null ? row[prop] : '' }}</span>

                <!-- <div v-else-if='column.ishtml'></div>  -->

                <div v-else-if='!column.islabel && column.buttons.length === 1' >
                  <el-button
                    v-if='type === "html" ? false : !column["onv-if"] ? column.btntext : column["onv-if"]($host,$this,row,column)'
                    v-show='!column["onv-show"] ? true : column["onv-show"]($host,$this,row,column)'
                    :type="column.btntype"
                    :style="column.btncolor && {color: $$themeobj[column.btncolor] || ( column.btncolor.substring(0,1) !== '(' ? '#'+column.btncolor : 'var' + column.btncolor )  }"
                    style='text-shadow:0px 0px 0px;'
                    @click="column.onclick && column.onclick($host,$this,row,column)"
                    >
                    {{ typeof column.btntext === 'string' ? column.btntext : column.btntext($host,$this,row,column)  }}
                  </el-button>

                  <el-button
                    v-else-if='type !== "html" ? false : !column["onv-if"] ? true : column["onv-if"]($host,$this,row,column)'
                    v-show='!column["onv-show"] ? true : column["onv-show"]($host,$this,row,column)'
                    :type="column.btntype"
                    :style="column.btncolor && {color: $$themeobj[column.btncolor] || ( column.btncolor.substring(0,1) !== '(' ? '#'+column.btncolor : 'var' + column.btncolor ) }"
                    style='text-shadow:0px 0px 0px;'
                    @click="column.onclick && column.onclick($host,$this,row,column)"
                    v-html="typeof column.btntext === 'string' ? column.btntext : column.btntext($host,$this,row,column)"
                    >
                    <!-- {{ typeof column.btntext === 'string' ? column.btntext : column.btntext($host,$this,row,column)  }} -->
                  </el-button>
                </div>

                <div v-else-if='column.buttons.length > 1' id='el-button'>
                  <span v-for='(column,index) in column.buttons' :key='index'>
                    <el-button
                      v-if='column && ( !column["onv-if"] ? column.btntext : column["onv-if"]($host,$this,row,column) )'
                      v-show='!column["onv-show"] ? true : column["onv-show"]($host,$this,row,column)'
                      :type="column.btntype"
                      :style="column.btncolor && {color: $$themeobj[column.btncolor] || ( column.btncolor.substring(0,1) !== '(' ? '#'+column.btncolor : 'var' + column.btncolor ) }"
                      style='text-shadow:0px 0px 0px;'
                      @click="column.onclick && column.onclick($host,$this,row,column)">
                      {{ typeof column.btntext === 'string' ? column.btntext : column.btntext($host,$this,row,column)  }}
                    </el-button>
                  </span>
                </div>

                <span v-else-if='column.labels.length < 2'
                  :style='{color: $$themeobj[tmp = column.$color$[row[prop] ] || column.$color$[""]] || tmp && ( tmp.substring(0,1) !== "(" ? "#" + tmp : "var" + tmp ) }'
                  style='text-shadow:0px 0px 0px;'
                  >
                  {{ ( column.islabel[ row[prop] ] || column.islabel[""] || "" ) }}
                </span>

                <div v-else>
                  <span
                    v-for='(column,index) in column.labels' :key='index'
                    :style='{color: $$themeobj[ tmp = column.$color$[ row[prop] ] || column.$color$[""] ] || tmp && ( tmp.substring(0,1) !== "(" ? "#" + tmp : "var" + tmp ) }'
                    style='margin-right:7px;text-shadow:0px 0px 0px;'>
                    {{ column[ row[prop] ] || column[""] || "" }}
                  </span>
                </div>

              </div>

              <!-- <button z-button style="width: 100%;position: relative;" onfocusout='console.error(document.activeElement)' xonfocus='console.warn("聚焦")' > xstyle="position: absolute;right: 34px;top: 50%;margin-top: -8px;font-size: 16px;cursor: pointer;color: var(--Colorlight);" -->
              <!-- <div style="position: relative;" class="FocusEditableBox"> -->
                <div v-if=' prop[0] !== "$" && updateapi_rule[prop] && row && ( row[ "$edit" + prop ] )' class="el-table-input" 
                  style="display: flex;width: 100%;align-items: center;justify-content: center;font-size: 17px;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    z-index: 777;
                    margin-top: -9px;
                  "
                  @focusout.stop='
                    !row.$$_editall_$$ &&
                    ( $stopPropagation ? $stopPropagation = false : window.sleep(50.159357,v=>blurEditable(row,prop)) )
                  ' >

                  <i class='el-icon-success cPointer'
                    style="color: var(--Colorlight);
                    position: absolute;
                    top: -18px;
                    z-index: 777;"
                    title="确定修改"
                    @mousedown.stop.capture='$stopPropagation=true'
                    v-set='el=>(A.hideProperty(row,"$$loadingel_"+prop,el).onclick=()=>blurEditable(row,prop,"updateapi",el))' />

                  <el-input
                    type='textarea' id='MinTextareaHeight'
                    :autosize='{minRows:1,maxRows:5}'
                    :align='col.align'

                    :value='(row[prop] != null ? row[prop] : "").replace("₯","")'
                    @input='row[prop] = arguments[0]'
                    change='row[prop] = arguments[0]'
                    blur='row[ "$edit" + prop ] = false, row[ prop ] = row["$" + prop]'

                    onkeydown='event.keyCode === 13 && (
                      event.ctrlKey || event.code === "NumpadEnter" && ( event.preventDefault(), true ) 
                    ) && this.parentNode.previousElementSibling.click();'
                    size='small'
                    style='width: 100%;'
                    >
                  </el-input>
                </div>
              <!-- </div> -->


          </template>
        </el-table-column>

      </el-table>

      <el-pagination
        v-if="paginate != 2"
        @size-change="$host.$trigger(bindapi,{$id$:binddata,currentPage:($host[bindata_key]||{}).currentPage,pageSize:arguments[0]})"
        @current-change="$host.$trigger(bindapi,{$id$:binddata,currentPage:arguments[0]})"
        :total="$total$=$host[bindata_key] && $host[bindata_key].total || databak.length || 0"
        :current-page.sync="($host[bindata_key]||{}).currentPage"
        :page-size.sync="$host[bindata_key] && $host[bindata_key].pageSize"

        remark="👆上面是自定义的,👇下面是固定的无需修改"

        :page-sizes="pageSizeList"
        background
        layout="slot,total, prev, pager, next, jumper, sizes" >
        <i  id='el-pagination-refresh' class='el-icon-refresh-right'
          :style='{animation: loading}'
          :self.prop='_self'
          @click.stop='
            !loading && (
              loading="rotate 0.4s linear infinite",
              $host.$trigger(bindapi,{$id$:binddata}).result(res=>{
                res && res.delay > 350 ? loading="" : window.sleep(250.0040101,v=>loading="");
              })
            );
          '
          onmouseenter="this.style.with({transform:'rotate(360deg) scale(1.2)',opacity: 0.85})"
          onmouseleave="this.style.with({transform:'',opacity:''})"
          ></i>
      </el-pagination>

    </section>
  </div>
</template>

<script>
import Vue from 'vue';
const $id$ = '__isMyTable_', hideProperty = A.hideProperty, getOwn = A.getOwn;
const W = window;
// console.error(Vue, 555555555555555555,66666);
const $forArr = forArr, $forObj = forObj;
let $Menus = W.$Menus;
let $Cachedfns;
let $CachedAsync = ((Func)=>{
  const Syncache = { __proto__: null };
  const Asyncache = { __proto__: null };
  $Cachedfns = (eva)=>{
    return Syncache[ eva ] || (
        Syncache[ eva ] =
        Func( 'return function(S,P,$row,$col){' + eva + '}' )()
      );
  };
  return (eva)=>{
    return Asyncache[ eva ] || (
        Asyncache[ eva ] =
        Func( 'return async function(S,P,$row,$col){' + eva + '}' )()
      );
  };
})(W.Function);

// const Cachedfns = A.cached(function(func){
//     return str=>func('$this','$row','$col','mytable','$el',str);
// }(W.Function));

// console.error($Cachedfns, $Menus);
const $Fixed = {
  __proto__: null,
  'fixed:left': 'left',
  'fixed:right': 'right',
  'fixed:false': false,
  'align:left': 'left',
  'align:center': 'center',
  'align:right': 'right',
  'sortable': true,
  // 'sortable:true': true,
  'sortable:false': false,
};
const $Support = [ 'title', 'istext', 'align', 'fixed', 'sortable', 'width', 'btncolor', 'btntext', 'btntype', 'btnstyle', 'onclick', 'labels', 'buttons' ];
let $MyTableList$ = A.$MyTableList$ = { __proto__: null };
A.reset$MyTableList$ = ()=>A.$MyTableList$ = $MyTableList$ = { __proto__: null };
// const $MyTableSlot$ = { __proto__: null };
// console.warn($MyTableList$);
const WatchLoading = function(state){
  const $host = this.$host;
  // state === 1 && console.warn(this.bindata_key, this, Object.keys($.notifyApiList) );
  if( $host.$stopSame === this.bindata_key  ) {
    // console.error(1111111111,$host.$stopSame,this.bindata_key,this);
    // state === 1 && sleep.clear(1.5789641232,v=>$host.$stopSame=0);
    return false;
  };
  this.$$clear$$();
  // switch( this._hookstate ) {
  //   case 'deactivated': return this.boolean = 0, false;
  //   // case 'activated':
  // };
  // console.error(state,this.bindapi,this.bindata_key,this.binddata,this);
  state === 1 && (
    this.firstRequest = false,
    /*$host.$stopSame !== this.bindata_key && */sleep(0,this.computeData)
    // this.computedData.length > 0 && sleep(0,()=>this.computedData = this.$host[ this.bindata_key ].data)
    // this.computedData = this.$host[ this.bindata_key ].data
  );
  if( this.boolean === 0 && state === 1 && this.dataReady === true ) return false;
  state === 0  //|| this.dataReady === false
  ? this.boolean = true
  : this.$$clear$$ = sleep(200.1).then(v=>this.boolean=0).clear
  // sleep(200,v=>$host.$stopSame=void 0);
  return false;
};
export default {
  name: 'MyTable',
  // get name() {
  //   // console.error(this);
  //   W.$Loaded && W.$Loaded();
  //   return 'MyTable';
  // },
  // set name(name) {

  // },
  // componentName: 'MyTable',
  props: [ 'data', 'height', 'tableColums', 'api', 'updateapi', 'type', 'tableData','nowData','paginate' ],
  data () {
    // this.lastTabledata = 0;
    // this.nextRows = []; //new W.Set();
    return {
      firstRequest: true,
      Apirule: 0,
      bindapi: '',
      bindrowkey: '',
      bindata_key: '',
      computedData: [],

      $$themeobj: this.$$themeobj,

      tableSelection: true,
      tableSelectionWidth: '',
      tableSelectionFixed: false,

      tableIndex: '序号',
      tableIndexWidth: '',
      tableIndexFixed: false,

      MyTableColums: { },

      /*tableColums_test: {
        $selection: true,     // 50
        $index    : "序号",   // [ "#序号|fixed:left?right|align:center", 100 ]

        loginname: "衍书号",
        username : "$auto",
        name     : "$auto",

        usex     : [ "$auto", 100, "@v-if: 1:男#success, 2:女#danger, :保密#warn" ],

        age      : [ "$auto", 60  ],
        utel     : [ "$auto | align:left", 120 ],

        utype    : [ "类型", 100, "@v-if: 1:普通用户#info, 2:老师#danger, 3:员工#warn" ],

        idcard   : [ "$auto | align:left", 160 ],

        logindata: [ "最近登录时间", 160 ],

       createdate: [ "创建时间", 160 ],

       state     : [ "状态", 100, "@v-if: 1:正常#success, 2:封号#danger+, 3:禁播#danger" ],


              $1$: [ "关注人列表", 100, `@text: 查看#warn
                    @click: selectMyAttention({userId:$row.id}),$form("selectMyAttention")` ],

              $2$: [ "圈子列表", 100, `@text: 查看#warn` ],

       $operation: [
          "操作 | fixed:right", 200,

          `@text: 封号#danger
           @html: <img src={{ $row.imgsrc }} />
           @v-if: $row.state != 2
           @click: $trigger("_confirm","封号")("updateState",2,$row)("selectContact")

          `,

          `@text: 解封#success
           @v-if: $row.state == 2
           @click: $trigger("_confirm","解封")("updateState",1,$row)("selectContact")
          `,

          `@text: 禁播#warn
           @v-if: $row.utype == 2 && $row.state == 1
           @click: $trigger("_confirm","禁播")("updateState",3,$row)("selectContact")
          `,

          `@text: 开播#success
           @v-if: $row.state == 3
           @click: $trigger("_confirm","解除禁播")("updateState",1,$row)("selectContact")
          `,

          `@text: 编辑#success
           @click: $form("editUser",$row)
          `,

          `@text: 删除#danger+
           @click: $trigger("_confirm","删除") ("deleteUser",{id:$row.id}) ("selectContact")
          `,

        ]

      }*/
    }
  },

  // watch
  watch: {
    nowData(n){
      console.log(n,this.computedData,this.tableData);
      if(n){
        this.computedData =this.nowData
      }
    },
    computedData() {
      // console.log(this.computedData)
      // console.error(77777777777778888);
      // const $host = this.$host;
      this.$emit('update',this);
      // console.error(this.bindata_key,this.bindapi,$host[this.bindata_key]);
    }
  },
  methods: {
    computeData() {
      // return this.databak = [];
      // console.warn(222222222);
      // if( App.Appload !== 'mounted' ) return this.$destroy(), this.databak = [];
      // if( !this._isMounted ) return this.databak = [];
      if( this.tableData ) return this.computedData = this.tableData !== this.pageSizeList ? this.tableData : [];
      const api = this.bindapi || this.api, $host = this.$host;
      // console.warn(333333333, api, this, this.bindata_key);
      let object = $host[ this.bindata_key ];
      if( object ) {
        let data = object.data || object.list;
        if( typeof data !== 'object' || data === null ) {
          for( let key in object ) {
            if( key[0] !== '$' && typeof (key = object[key]) === 'object' && key !== null ) {
              data = key;
              break;
            };
          };
        };
        object = data;
      };
      // console.error(555555,object,this.bindata_key,api,77777777);
      // sleep(0,()=>{
      //   this.lastTabledata = object;
      //   console.error('完毕!');
      // });
      // console.warn(object,$host[ this.bindata_key ],this.bindata_key,this);
      return this.computedData = this.databak = ( object = object || [] )  !== this.pageSizeList ? object : [];
    },

    parseTableColums(tableColums,ifexist) {
      let temp, selection, index, fixed = false, width = '';
      // console.error(789456);
      tableColums = tableColums || this.tableColums;

      if( selection = tableColums.$selection ) {
        typeof selection === 'object' && selection !== null && ( [ temp, fixed ] = selection );
        this.tableSelectionWidth = temp > 1 ? temp : '';
        this.tableSelectionFixed = fixed ? fixed.replace('fixed:','') : false;
        this.tableSelection = true;
      }else selection = this.tableSelection = selection !== false;

      // console.warn(selection,this);

      if( index = tableColums.$index ) {
        ( temp = index ) === true
        ?  temp = '序号'
        :  typeof index === 'object' && index !== null && ( [ temp, width ] = index );
        temp = temp.split('|');
        // console.error( index );
        this.tableIndex = temp[0].trim(), fixed = temp.length === 1 ? false : temp[1].trim();
        // console.error( index, this );
        // this.tableIndex = temp;
        this.tableIndexWidth = width > 1 ? width : "";
        this.tableIndexFixed = fixed ? fixed.replace('fixed:','') : false;
        // console.error( this.tableIndexFixed, fixed );
      } else index = index === false ? this.tableIndex = '' : true;

      if( ifexist ) return tableColums;

      tableColums.$selection = tableColums.$index = void null;

      const  Cachedfns   = $Cachedfns   || ( $Cachedfns = W.$Cachedfns );
      // console.warn(Cachedfns);
      const  CachedAsync = $CachedAsync || ( $CachedAsync = W.$CachedAsync );

      const $host = this.$host;
      const $apirule  = this.$apirule = ( temp = ($Menus||($Menus=W.$Menus)).Apis[ this.bindapi||this.api ] ) && temp.$thismenu.$rule || 0;
      const MyTableColums = { __proto__: null };
      const Fixed = $Fixed;

      $forObj( tableColums, (v,k) => {
        // console.warn(k,v);
        if( v === null || v === void null ) return;
        let temp = false, index, width, fixed = '', buttons = [];
        let type = typeof v;
        if( type !== 'string' ) [ v, width, ...buttons ] = v;
        // console.warn(v,k);
        index = [ v, fixed, temp ] = v.split('|');
        // console.warn(v,k);
        index.length === 1
          ? ( fixed = '', temp = '' )
          : ( fixed = fixed.trim(), temp = index.length === 2 ? '' : temp.trim() );

        const labels = [];
        const obj = MyTableColums[ k ] = {
          __proto__: null,
          // title: ( v = v.trim() ) === '$auto' ? ( k = $apirule[ k ] ) && k.label || '?' : v,
          // istext: false,
          // align: fixed[0] === 'a' && Fixed[ fixed ] || 'center',
          // fixed: fixed[0] === 'f' && Fixed[ fixed ] || false,
          // width: width || '',
          // btncolor: '',
          // btntext: '',
          // btntype: '',
          // onclick: '',
          // labels: labels,
          // buttons: buttons
        };
        hideProperty( obj, 'title', ( v = v.trim() ) === '$auto' ? ( k = $apirule[ k ] ) && k.label || '?' : v );
        hideProperty( obj, 'istext', false );
        hideProperty( obj, 'align', fixed[0] === 'a' && Fixed[ fixed ] || 'center' );
        hideProperty( obj, 'fixed', fixed[0] === 'f' && Fixed[ fixed ] || false );
        hideProperty( obj, 'sortable', fixed[0] === 's' && Fixed[ fixed ] || false );
        hideProperty( obj, 'width', width || '' );
        hideProperty( obj, 'btncolor', '' );
        hideProperty( obj, 'btntext', '' );
        hideProperty( obj, 'btntext0', '' );
        hideProperty( obj, 'btntype', '' );
        hideProperty( obj, 'onclick', '' );
        hideProperty( obj, 'onclick0', '' );
        hideProperty( obj, 'labels',  labels );
        hideProperty( obj, 'buttons', buttons );

        if( type === 'string' || buttons.length ===  0 ) {
          obj.istext = true;
          return;
        };

        // temp === false && ( buttons[buttons.length++] = fixed );
        let eachindex = 0;
        for( fixed of buttons ) {
          if( !fixed ) continue;
          fixed = fixed.trimLeft();
          if( ( type = fixed.slice(1,( temp=index=fixed.indexOf(':') ) !== -1 ? index : void 0 ) ) !== 'v-if' ) {
              const isbutton = { __proto__: null };
              index =  fixed.slice(1).indexOf('@');
              temp = fixed.slice(temp+1, index !== -1 ? ++index : void 0 ).trim().split('#');
              isbutton.btncolor = obj.btncolor = (temp[1]||'').trim();
              if( ( temp = temp[0].trim() )[0] !== '{' ) {
                isbutton.btntext  = obj.btntext  =  temp;
              }else {
                isbutton.btntext  = obj.btntext  =  (
                  isbutton.btntext0  = obj.btntext0 = Cachedfns( 'with(S){return ' + temp.slice(2,-2).trim() + '}' )
                ) // .bind($host,this,$host,0,0,0,0,0);
              };
              // isbutton.btnstyle = obj.btnstyle = (temp[2]||'').trim();
              isbutton.btntype = obj.btntype = type;
              if( index !== -1 ) {
                for( index of fixed.slice(index+1).split('@')) {
                  index = index.trimLeft();
                  temp = index.indexOf(':');
                  type = 'on' + index.slice( 0, temp );
                  // console.warn(type);
                  index = index.slice(temp+1).trim();
                  // obj[ type ] = isbutton[ type ] = index[0] === '{' ? index.slice(2,-2).trim() : index;
                  // index[0] === '{'  && ( index = 'return ' + index.slice(2,-2).trim() );
                  // console.warn(type,index);
                  obj[ type ] = isbutton[ type ] = (
                    obj[ type + '0' ] = isbutton[ type + '0' ] = (
                      type !== 'onclick'
                      ? Cachedfns( 'with(S){return ' + index.trim() + '}' )
                      : CachedAsync( 'with(S){' + index.trim() + '}' )
                    )
                  ) // .bind($host,this,$host,0,0,0,0,0);
                };
                // temp = fixed.slice(index+7);
                // console.error(index, fixed);
                // ( temp[0] === '"' || temp[0] ==="'" ) && ( temp = temp.slice(1,-1) );
                // isbutton.onclick = obj.onclick = temp;
              };
              buttons[eachindex++] = isbutton;
          }else {
            // console.error(fixed,999999);
            const islabel = { __proto__: null };
            const $color$ = obj.$color$ = islabel.$color$ = { __proto__: null };
            fixed.slice(index+1).split(',').forEach((v,f)=>{ // 1:男#success
              f = ( v = v.split(':') )[0].trim();
              v = v[1].split('#');
              islabel[ f ] = v[0].trim();
              $color$[ f ] = v.length === 1 ? '' : v[1].trim();
              // f === '' && ( islabel.$else$ = t, $color$.$else$ = v2.trim() );
            });
            labels[labels.length++] = obj.islabel = islabel;
          };
        };

      });

      // tableColums.$selection = selection, tableColums.$index = index;
      hideProperty( MyTableColums, '$selection', selection )
      hideProperty( MyTableColums, '$index', index );
      // console.warn(MyTableColums,1111111111);
      return MyTableColums;
    },

    focusEditable( row, prop, focus ) {
      // console.warn(row,prop,this.updateapi);
      if(this.updateapi === false) return false;
      if( !row.hasOwnProperty('$edit'+prop)  ) return false;
      focus = "$edit" + prop;
      if( row[ focus ] ) return false;
      row[ focus ] = true;
      row[ prop ] = "₯" + row[ prop ];
      return true;
    },
    blurEditable: async function( row, prop, updateapi, loadingEl ){
      this.$stopPropagation = false;
      let updated;
      if( updateapi === 'updateapi' ) {
        // alert('message?: DOMString');
        // console.error(row,loadingEl);
          updated = row[prop][0] !== '₯' ? row[ prop ] : row['$'+prop];
          if( updated !== row['$'+prop] ) {
            loadingEl = loadingEl || row[ '$$loadingel_' + prop ];
            loadingEl.classList.replace('el-icon-success','el-icon-loading');
            // console.warn('修改成功:: ', updated, row[prop], row['$'+prop] );
            const params = { __proto__: null };
            $forObj( row, (value,key)=> {
              params[ key ] = getOwn( row, [ '$' + key ], value );
            });
            params[ prop ] = updated;
            // console.error(params);
            const res = await this.$post( this.updateapi, params, null );
            // console.warn(res);
            if( res.isuccess ) alertSuccess( res.data && res.data.msg || '修改成功!!' );
            await sleep(20);
            loadingEl.classList.replace('el-icon-loading','el-icon-success');
            if( !res.isuccess ) return false;
          }else loadingEl = false;
        // row["$" + prop] = updated;
        // return;
      } else if( updateapi === 'updateapiall' ) {
        let params = { __proto__: null }, needupdate = [];
        for( prop in row ) {

          if( getOwn( row, '$' + prop, false ) === false ) { params[ prop ] = row[ prop ]; continue; };

          updated = row[prop][0] !== '₯' ? row[ prop ] : row['$'+prop];
          params[ prop ] = updated;

          updated !== row['$'+prop] && needupdate.push( prop );

        };

        if( needupdate.length > 0 ) {
          loadingEl.classList.replace('el-icon-success','el-icon-loading');
          for( prop of needupdate ) {
            row[ '$$loadingel_' + prop ].classList.replace('el-icon-success','el-icon-loading');
          };
          const res = await this.$post( this.updateapi, params, null );
          // console.warn(res);
          if( res.isuccess ) alertSuccess( res.data && res.data.msg || '修改成功!!' );
          await sleep(20);
          loadingEl.classList.replace('el-icon-loading','el-icon-success');
          for( prop of needupdate ) {
            row[ '$$loadingel_' + prop ].classList.replace('el-icon-loading','el-icon-success');
          };
          if( !res.isuccess ) return false;

        };

        loadingEl = false;
        for( prop in params ) {
          if( getOwn( row, '$edit' + prop, false ) === false ) continue;
          row[ "$edit" + prop ] = false;
          row[ prop ] = row["$" + prop];
          row[ "$$loadingel_" + prop ] = false;
        };

        if( needupdate.length > 0 ){
          await this.$nextTick();
          for( prop of needupdate ) {
            row[ prop ] = row["$" + prop] = params[ prop ];
          };
        };

        // console.error(needupdate, params, row );
        return true;
      };
      // console.warn('修改成功:: ', updated, row[prop], row['$'+prop] );
      row[ "$edit" + prop ] = false;
      row[ prop ] = row["$" + prop];
      if( loadingEl ) {
        await this.$nextTick();
        row[ prop ] = row["$" + prop] = updated;
        // ( loadingEl = loadingEl.parentNode ).style.display = 'none';
        // loadingEl.previousElementSibling.style.display = '';
      };
      // console.warn('修改成功:: ', updated, row[prop], row['$'+prop] );
      return true;
    },

    watchApi() {
      this.$unwatchapi && this.$unwatchapi();
      this.$unwatchapi = this.$watchapi( this.binddata, WatchLoading );
      // console.error('开始监视Api.....',this.binddata,this);
    },

    watchTable() {
      const Appload = App.Appload;
      // console.warn('开始监视表格.....', this.$refs.table, this.firstRequest );
      this.$refs.myBind('table',Table=>{
        // console.warn('!!成功监视表格....',Table,this, Appload);
        if( !Table ) return;
        Appload === 'mounted' && (
          this.dataReady = true,
          !this.$route.meta.refresh && ( this.boolean = 0, this.firstRequest = false )
        );
        // console.log( Appload, Appload === 'mounted' );
        // console.warn('!!成功监视表格....',Appload, this.dataReady, Appload === 'mounted', Table,  this, this.$route.meta.refresh);
        // this.$$clear$$(), this.$$clear$$ = sleep(202.87).then(v=>this.dataReady=true).clear;
        const $host = this.$host, bindata_key = this.bindata_key;
        const $Cache = this.$MyTableCache = $host.$MyTableCache = { __proto__: null }, ID = this.bindrowkey;
        hideProperty( $Cache, "$Newrow", 0 );
        hideProperty( $Cache, "$Oldrow", 0 );
        hideProperty( $Cache, "$Eltable", 0 );
        // console.warn($Cache,hideProperty);
        // hideProperty( $Cache, "$Selection", [] );
        const dataCache = ( this.Table = $host[bindata_key].$table = $Cache.$Eltable = Table ).$MyTableCache = $Cache;

        Table.$on( 'row-click', (row,column,isel)=>{
            const hasel = this.tableSelection;
            console.log(hasel);
            if( hasel ) {
              isel = Table.selection;
              Table.clearSelection();
              Table.toggleRowSelection( row, isel.length > 1 || isel[0] !== row  ? true : false );
              // console.error(row,isel);
            };
            ( isel = $host[ bindata_key ] ).$row = row || 0;
            this.updateapi_data && (
              this.updateapi_data.$row = row || 0
            );
            this.$emit( 'row-click', row, column, Table, this );

            if( hasel )
              this.$emit( 'select', isel.$selection = [row], row, dataCache, Table, this );
        } );

        if( !this.tableSelection ) {
          Table.$watch('tableData',(data,oldata,id)=>{
            this.dataReady !== 1 && this.$nextTick(()=>this.dataReady=1);
            this.$$clear$$(), this.$$clear$$ = sleep(50.55).then(s=>this.boolean=0).clear;
          });
          return;
        };

        const forArr = $forArr;
        // console.warn(ID,999999999);
        Table.$on( 'current-change', (row,oldRow,tmp)=>{
          $host[ bindata_key ].$row = dataCache.$Newrow = row||0, dataCache.$Oldrow = oldRow||0;
          // console.error(row,oldRow);
          // this.updateapi_rule && (
          //   ( tmp = this.updateapi_data ).$row = row || 0
          // );
          this.$emit('current-change', row, oldRow, Table, this);
        });

        if( ID === '' ) {
          // const newSet = new W.Set();
          Table.$watch('tableData',(data,oldata,id)=>{
            // console.error(data,111111);
            $host[ bindata_key ].$row = 0;
            this.dataReady !== 1 && this.$nextTick(()=>this.dataReady=1);
            this.$$clear$$(), this.$$clear$$ = sleep(50.55).then(s=>this.boolean=0).clear;
          });

          Table.$on('select',(selection,row,id)=>{
            this.$emit( 'select', $host[ bindata_key ].$selection = selection, row, dataCache, Table, this );
          });

          Table.$on('select-all',(selection,row)=>{
            this.$emit( 'select', $host[ bindata_key ].$selection = selection, void 0 + 1, dataCache, Table, this );
          });
          return;
        };

        let currentData = [];
        // console.error( ID, dataCache );
        Table.$watch('tableData',(data,oldata,id,isel)=>{
          // console.error(data,111111);
          id = ( dataCache.$Newrow || dataCache.$Oldrow ) [ ID ];
          forArr( currentData = data, (v,i) => {
            dataCache[ i = v[ ID ] ] && (
              Table.toggleRowSelection( v, isel = true ),
              $host[ bindata_key ].$row = v
            );
            id === i && id != null && Table.setCurrentRow( v );
          });
          isel !== true && ( $host[ bindata_key ].$row = 0 );
          // console.error(9999999999999);
          // console.warn(this.dataReady,'准备好了表格!!!!',Appload);
          this.dataReady !== 1 && this.$nextTick(()=>this.dataReady=1);
          this.$$clear$$(), this.$$clear$$ = sleep(50.55).then(s=>this.boolean=0).clear;
        });

        /*Table.$watch('selection',selection=>{
          // console.error(selection);
        });*/

        Table.$on( 'row-click', (row,column,isel)=>{
          isel = Table.selection;
          // console.error(isel);
          Table.clearSelection(), forArr( currentData, v=>delete dataCache[ v[ID] ] );
          Table.toggleRowSelection( row, isel.length > 1 || isel[0] !== row  ? dataCache[ row[ID] ] = true : false );

          $host[ bindata_key ].$row = row;
          // console.error( isel, $host, bindata_key );
          this.$emit( 'row-click', row, dataCache, column, Table, this );
          this.$emit( 'select', $host[ bindata_key ].$selection = [row], row, dataCache, Table, this );
        } );

        Table.$on('select',(selection,row,id)=>{
          // console.error(111, selection,row);
          dataCache[ id = row[ ID ] ]
          ? delete dataCache[ id ]
          : dataCache[ id ] = true;
          this.$emit( 'select', $host[ bindata_key ].$selection = selection, row, dataCache, Table, this );
        });

        Table.$on('select-all',(selection,row)=>{
          // console.error(222, selection,row);
          selection.length === 0
          ? forArr( currentData, v=>delete dataCache[ v[ID] ] )
          : forArr( currentData, v=>dataCache[ v[ID] ] = true );
          this.$emit( 'select', $host[ bindata_key ].$selection = selection, void 0 + 1, dataCache, Table, this );
        });

      });
    }

  },

  /*beforeCreate() {
    // debugger;
    // console.error( this );
    //W.$Loaded();
    // this.Cachedfns   = Cachedfns;
    // this.CachedAsync = CachedAsync;
    // this.MyTableSlot = $MyTableSlot$;
  },*/


  created(){
    
    // this.$unwatch && this.$unwatch();
    // console.warn('初始化加载我的table...', this._hookstate, W.Appload, this.$route.meta.gotoMode, this.$route.meta.refresh);
    // this.boolean = true;
    // console.log('当前表格: ',W.t=this, this.api);
    this.databak = [];
    let $host = this.$host, temp = this.api.split('::'), ID = this.bindrowkey = temp.length > 1 ? temp[1].trim() : '';
    // temp = typeof this.data === 'string';
    let bindata_key = this.bindapi = this.bindata_key = temp[0].trim(), binddata;
    // console.warn($host[this.bindapi+'_data'], bindata_key, this.api, $host);

    const Apiparams = $host.Apiparams, updateapi = this.updateapi;
    this.updateapi_rule = updateapi && ( binddata = this.updateapi_data = $host[updateapi + '_data'] ) && (
      hideProperty( binddata, '$$updateapi', {__proto__:null} ),
      hideProperty( binddata, '$mytable', this ),
      hideProperty( binddata, '$row', 0 ),
      // hideProperty( binddata, '$selection', [] ),
      // hideProperty( binddata, '$table', 0 ),
      Apiparams[ '$rule_' + updateapi ]
    ) || {__proto__:null};
    // console.error(this.api,11111111, ID, this, App.Appload, [ currentFn ]);
    // if( App.Appload !== 'mounted' ) return this.$destroy();

    ( binddata = $host[ bindata_key = this.bindata_key = ( this.binddata = typeof this.data === 'string' && this.data || this.bindapi || '$' ) + '_data' ] )
    ? ( $host.$set( binddata, '$row', 0 ), $host.$set( binddata, '$selection', [] ), binddata.$table = 0  )
    : (
      // console.error(Vue, Vue.observable ),
      binddata = $host[ bindata_key ] = Vue.observable( {
          data: [],
          currentPage: this.$Global.currentPage,
          pageSize: this.$Global.pageSize,
          total: 0,
          $row: 0,
          $selection: [],
          $table: 0,
          // $$lastparams: {},
          // $$lastres: {}
      }),

      /*W.myBind('currentFn',fn=>{
        console.error(fn);
      }),
      console.warn(W,W.currentFn),*/
      binddata.hideProperty('$$lastres',0).hideProperty('$$lastparams',0),
      // console.error(bindata_key + '.data', binddata ),
      this.$unwatch = $host.$watch( bindata_key[0] !== '/' ? bindata_key + '.data' : ()=>$host[bindata_key].data, res=>{
        console.error( res, 5555, this.bindata_key );
        // $host.$set(res,'currentRow',);
        res = getOwn( res, 'total' );
        res === res && ( $host[bindata_key].total = res );
      }),
      bindata_key[0] === '/' && $host.$trigger(this.binddata,With({currentPage:1,pageSize:binddata.pageSize},this.data))
    );

    // console.error(bindata_key+'.data');
    // $host.$watch(bindata_key+'.data',data=>{
    //   console.error(data);
    // });
    this.$$clear$$ = ()=>{};
    this.watchApi();
    this.watchTable();

    binddata.hideProperty( '$mytable', this );

    let tableColumsID = $host.$$path + '::' + this.api;
    // console.error(this.bindapi,this.api);
    var MyTableColums = $MyTableList$[ tableColumsID ]; //this.tableColums_test;
    // console.warn( $MyTableList$, MyTableColums, tableColumsID );
    if( MyTableColums ) {

      this.parseTableColums( MyTableColums, true );

      let key, value, sonobj, sonkey, tmp, buttons, newobj = { __proto__: null };

      for( key in MyTableColums ) {
        sonobj = newobj[ key ] = { __proto__: null };
        for( sonkey of $Support ) {
          hideProperty( sonobj, sonkey, MyTableColums[key][sonkey] );
          // console.warn([ key, sonkey ]);
        };
        // console.warn(key, sonobj.buttons);
        for( buttons of ( tmp = sonobj.buttons ) ) {
          if(!buttons) continue;
          buttons[ 'onclick0' ] && ( buttons[ 'onclick' ] = buttons[ 'onclick0' ] ); // .bind($host,this,$host,0,0,0,0,0) );
          buttons[ 'onv-if0' ] && ( buttons[ 'onv-if' ] = buttons[ 'onv-if0' ] ); // .bind($host,this,$host,0,0,0,0,0) );
          buttons[ 'onv-show0' ] && ( buttons[ 'onv-show' ] = buttons[ 'onv-show0' ] ); // .bind($host,this,$host,0,0,0,0,0) );
          typeof buttons[ 'btn-text0' ] === 'function' && ( buttons[ 'btn-text' ] = buttons[ 'btn-text0' ] ); // .bind($host,this,$host,0,0,0,0,0) );
        };

        tmp.length === 1 && ( tmp = tmp[0] ) && (
          sonobj[ 'onclick' ] = tmp[ 'onclick' ],
          sonobj[ 'onv-if' ] = tmp[ 'onv-if' ],
          sonobj[ 'onv-show' ] = tmp[ 'onv-show' ],
          sonobj[ 'btn-text' ] = tmp[ 'btn-text' ]
        );

      };

      // console.error(newobj,MyTableColums);

      this.MyTableColums = MyTableColums;

    } else {
      let tableColums;
      MyTableColums = this.MyTableColums = this.parseTableColums(
        tableColums = this.tableColums || []
      );
      hideProperty( tableColums,   '$$bindvuepage$$', tableColumsID );
      hideProperty( MyTableColums, '$$bindvuepage$$', tableColumsID );
      $MyTableList$[ tableColumsID ] = MyTableColums;
    };

    // console.error(MyTableColums.$this, MyTableColums);
    ( tableColumsID = MyTableColums.$this || [] ).firstRequest = tableColumsID.boolean = 0;
    hideProperty( MyTableColums, '$this', this );
    // console.error(this.tableColums, this.MyTableColums, $MyTableList$);

    // console.error(this._hookstate);

  },

  mounted( ) {
   
    // const data = this.$host[ this.bindata_key ];
    // console.error( this.computedData, data );
    // this.computeData();
    // console.warn(this);
  },

  activated() {
    // console.warn('activated:激活了......', this._hookstate, Appload);
   
    if( this._hookstate === 'mounting' ) return;
    this._hookstate = this.$host._hookstate = 'activated';
    const meta = this.$route.meta;
    const from = meta.from;
    this.watchApi();
    // console.error( from.gotoMode, this.$route.meta.gotoMode );
    if( !from.notstaticrefresh && from.gotoMode )
    // console.error(this.bindapi, from, 11111, from && from.notstaticrefresh, from.gotoMode);
      this.boolean = true;
    from.gotoMode = meta.gotoMode = '';
  },

  deactivated() {
    // this.$host.$$path.includes('WaitGoThroughVideo') &&
    console.error('失去了焦点....');
    this._hookstate = this.$host._hookstate = 'deactivated';
    this.$unwatch && this.$unwatch();
    this.$unwatchapi && this.$unwatchapi();
    const clear = getOwn(this,"$$clear$$");
    clear && clear();
    this.boolean = 0;
  },

  destroyed() {
    console.error('破坏了........');
    this.$unwatch && this.$unwatch();
    this.$unwatchapi && this.$unwatchapi();
    // this.$unwatchapi && this.$unwatchapi();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #el-button > span > .el-button {
    margin-right: 10px;
  }
  #el-button > span:last-child > .el-button {
    margin-right: 0px;
  }
</style>



























<!--  案例1 -->

  <!--
      section 包裹了两个组件: el-table 表格 + el-pagination分页 它们两个通常是不可分割的整体
      /* 👇 通过 $trigger("_confirm",参数a,参数b,...) 用来【！触发！】下面的 v-event  👇 */
  -->
  <mytable
    :tableColums='tableColums_main'

    api='selectContact'
    x:data='array||[]'

    v-event._confirm='a=>_confirm(a === "删除" ? "确定要删除该用户吗?" : "确定对该用户进行" + a + "处理吗?")'
    v-event.updateState='(a,$row)=>updateState({id: $row.id, state: a })'

    :height="height||H-165"

    @current-change="(row,oldrow,table)=>{}"

    @row-click="(row,oldrow,table)=>{}"

    ></mytable>



<!-- 原始old备份 -->


<!-- section 包裹了两个组件: el-table 表格 + el-pagination分页 它们两个通常是不可分割的整体, 一块加上 -->

<section>

  <el-table
    :data="selectContact_data.data||[]"
    xcurrent-change="currentChange"

    remark="👆上面是自定义的,👇下面是固定的无需修改"

    ref='table' v-view::selectContact_data.data
    :height="H-165"
    :header-cell-style="$$headerStyle"
    highlight-current-row border
    xcache:userId='_rowCache(arguments,arguments[4] && toShow)' >

    <div v-for='(column,index) in tableColums' :key='index'>

      <el-table-column
          v-if='column.index'    :fixed='column.fixed !== void 0 && column.fixed'
          :label='column.label||(tmp=Apiparams.$rule[column.prop])&&tmp.label||""'
          :type='column.type||""'   :index='column.index'
          :width='column.width||""' :align='column.align||"center"'
          :class-name='column["class-name"]||""' />

      <el-table-column
        v-else-if='column.type' :fixed='column.fixed !== void 0 && column.fixed'
        :type='column.type||""'   :label='column.label||(tmp=Apiparams.$rule[column.prop])&&tmp.label||""'
        :width='column.width||""' :align='column.align||"center"'
        x:show-overflow-tooltip='!column["show-overflow-tooltip"]'
        :class-name='column["class-name"]||""'></el-table-column>



      <el-table-column v-else
        :type='column.type||""'
        :fixed='column.fixed !== void 0 && column.fixed'
        :prop='column.prop||""'
        :label='column.label||(tmp=Apiparams.$rule[column.prop])&&tmp.label||""'
        :align='column.align||"center"'
        :width='column.width||""'
        :class-name='column["class-name"]||""'
        :show-overflow-tooltip='column["show-overflow-tooltip"]!==false'
        >
        <template slot-scope="scope">

          <div v-if='!column.template'>

            <span v-if='column.mayEdit===false'>{{ row[column.prop] }}</span>

            <div v-else id='Tablediter'
              :elrow.prop='row' :elprop.prop='column.prop||""'
              z:to='{ show:false, text:null, row:e.elrow, prop:e.elprop, last:e.elrow[e.elprop] }'>
              <div z:show='t.show' style="transition:all 200ms linear;">
                <el-input vshow='false' size=small style="width:80%;" v-model='row[column.prop]' vs='e=>e.children[0].select()' z:style='t.show && e.select(),"text-align:center"' oblur='t.row[t.prop]=t.last,t.show=false' o:enter='t.text=t.last=t.row[t.prop]=e.value,t.show=false' o:blur='(v=>
                  document.activeElement!==$(e).$next().firstElementChild
                  && ( t.row[t.prop] = t.last, t.show = false )
                ).sleep(22)' o:ready='t.input=e'>
                  <el-button slot="append" icon="el-icon-success" size=mini o:click='t.input._view("enter")'></el-button>
                </el-input>
              </div>
              <span o:click='t.show=!t.show' z:hide='t.show' z:text='t.text'>{{ row[column.prop] }}</span>
            </div>

          </div>

          <mytemplate v-else-if='typeof column.template === "function"'
            :template='column.template(scope.row,scope)'
            :row='scope.row'
            :context='column.context||_self'  />

          <mytemplate v-else
            :template='column.template'
            :row='scope.row'
            :context='column.context||_self' />

        </template>
      </el-table-column>

    </div>

  </el-table>


  <el-pagination
    @size-change="$trigger('selectContact')"
    @current-change="$trigger('selectContact')"
    :total="selectContact_data.total || 0"
    :current-page.sync="selectContact_data.currentPage"
    :page-size.sync="selectContact_data.pageSize"

    remark="👆上面是自定义的,👇下面是固定的无需修改"

    :page-sizes="pageSizeList"
    background
    layout="total, prev, pager, next, jumper, sizes" />

</section>


/* 在这里 动态渲染你的 tableColums表格列, 哪一列不需要, [!注释掉 或 删除掉!] 即可 ; 还可以在这里 [!增改!] 列 */
tableColums: [
  { type: 'selection', 'class-name': 'el-table-index', mayEdit: false, fixed:'left' }, // 多选checkbox
  { type: 'index', label: '序号', 'class-name': 'el-table-index', index: this.$$setIndex.bind(this,'selectContact'), width: 50, mayEdit: false, }, // 序号

  { prop: 'loginname',  label: '衍书号', },
  { prop: 'username',  label: '用户名', },
  { prop: 'name',  label: '姓名', },

  { prop: 'usex', label: '性别', template:($row,$scope)=>{ // row: 代表当前行这一条数据 context: 代表指向当前页面 this
    // console.error($row.state);
    return `
      <span type="text" v-if="$row.usex==1" style="color:#409EFF" @click="">男</span>
      <span type="text" v-else-if="$row.usex==2" style="color:#F56C6C">女</span>
      <span type="text" v-else style="color:#E6A23C">保密</span>
    `;
  }, mayEdit: false,width:'60px'   },

  { prop: 'age',  label: '年龄', width:'60px'},
  { prop: 'utel',  label: '电话', width:'120px'},

  { prop: 'utype', label: '类型', template:($row,$scope)=>{ // row: 代表当前行这一条数据 context: 代表指向当前页面 this
    // console.error($row.state);
    return `
      <span v-if="$row.utype==1" type="text" style="color:#67C23A" @click="">普通用户</span>
      <span v-else-if="$row.utype==2" type="text" style="color:#409EFF">老师</span>
      <span v-else type="text" style="color:#F56C6C">员工</span>
    `;
  }, mayEdit: false,width:'100px'   },

  { prop: 'idcard',  label: '身份证号',width:'160px' },
  { prop: 'logindate',  label: '最近登陆时间',width:'160px' },
  { prop: 'createdate',  label: '创建时间',width:'160px' },
   { prop: 'state', label: '状态', template:(row,context)=>{ // row: 代表当前行这一条数据 context: 代表指向当前页面 this
    // console.error(row.state);
    return Case(row.state,{
      1: '<span type="text" style="color:#67C23A" @click="row,context">正常</span>',
      2: '<span type="text" style="color:#F56C6C">封号</span>',
      3: '<span type="text" style="color:#E6A23C">禁播</span>',
    });
  }, mayEdit: false,width:'100px'   },

  { label: '关注人列表', context: this, template($row,$scope){ // $row: 代表当前行这一条数据
    return `
      <div>
        <el-button
          type="text"
          style="color:#409EFF"
           @click="selectMyAttention({userId:$row.id}),actived='selectMyAttention'"
          >查看</el-button>
      </div>
    `;
  }, mayEdit: false,width:'100px'   },

  { label: '圈子列表', context: this, template($row,$scope){ // $row: 代表当前行这一条数据
    return `
      <div>
        <el-button
          type="text"
          style="color:#409EFF"
         @click=""
          >查看</el-button>
      </div>
    `;
  }, mayEdit: false,width:'100px'   },

  { label: '操作', context: this, template($row,$scope){ // $row: 代表当前行这一条数据
    // v-event:click.confirmdel:deleteUser:selectContact=
    return `
      <div>
        <el-button
          type="text"
          style="color:#F56C6C"
           v-if='$row.state != 2'
         @click="_confirm('确定对该用户进行封号处理吗?').then(id=>updateState({id:$row.id,state:2}).selectContact())"
          >封号</el-button>
        <el-button
          type="text"
          style="color:#409EFF"
           v-if='$row.state ==2'
         @click="_confirm('确定对该用户进行解封处理吗?').then(id=>updateState({id:$row.id,state:1}).selectContact())"
          >解封</el-button>
        <el-button
          type="text"
          style="color:#E6A23C"
          v-if='$row.utype ==2 && $row.state == 1'
         @click="_confirm('确定对该用户进行禁播处理吗?').then(id=>updateState({id:$row.id,state:3}).selectContact())"
          >禁播</el-button>
          <el-button
          type="text"
          style="color:#409EFF"
           v-if='$row.state ==3'
         @click="_confirm('确定对该用户进行解除禁播处理吗?').then(id=>updateState({id:$row.id,state:1}).selectContact())"
          >开播</el-button>
        <el-button
          type="text"
          style="color:#67C23A"
          @click="$form('editUser',$row)"
          >编辑</el-button>
        <el-button
          type="text"
          style="color:#F56C6C"
          @click="_confirm('确定要删除该用户吗?').then(id=>deleteUser({id:$row.id}).selectContact)"
          >删除</el-button>
      </div>
    `;
  }, mayEdit: false,fixed:'right',width:'200px'   },

],



// WEBPACK FOOTER //
// src/components/$MyTable.vue